import { useState } from "react";
import PropTypes from "prop-types";
import { uniqueId } from "lodash";

const Textarea = ({
  title,
  headTitle,
  className,
  rows,
  cols,
  placeholder,
  name,
  defaultValue,
  value,
  disabled,
  isRequired,
  onChange,
  textareaProps,
  props,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [id] = useState(uniqueId("textarea-"));
  return (
    <div className="w-100">
      {title && (
        <label className="form-label text-uppercase fw-bold pb-0" htmlFor={id}>
          {title}
        </label>
      )}
      <fieldset
        className={`fieldset d-flex align-items-start bg-white ${
          headTitle ? "flex-column" : ""
        } ${isActive ? "input-active" : ""}`}
      >
        {headTitle && (
          <p className="headTitle text-secondary fw-bold mb-0 ms-1 px-2">
            {headTitle}
          </p>
        )}
        <textarea
          id={id}
          className={`input form-control ${className ? className : ""}`}
          name={name}
          value={defaultValue || value}
          required={isRequired}
          disabled={disabled}
          onClick={() => setIsActive(true)}
          onBlur={() => setIsActive(false)}
          onChange={onChange}
          placeholder={placeholder}
          rows={rows}
          cols={cols}
          {...textareaProps}
        ></textarea>
      </fieldset>
    </div>
  );
};

Textarea.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
  rows: PropTypes.number,
  cols: PropTypes.number,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  textareaProps: PropTypes.object,
  props: PropTypes.object,
};

export default Textarea;
